import React from "react";
import { useLocale } from "lib/hooks/useLocale";
import {
  DialogHeader,
  DialogBody,
  DialogFooter,
  GenericDialog,
} from "components/common/dialogs/GenericDialog";
import { X } from "@phosphor-icons/react";
import { useMerchantContext } from "lib/contexts/MerchantProvider";

interface UrgencyNudgePopupProps {
  isOpen: boolean;
  closePopup: () => void;
  closeCheckout: () => void;
}

const UrgencyNudgePopup: React.FC<UrgencyNudgePopupProps> = ({ isOpen, closePopup, closeCheckout }) => {
  const { t } = useLocale();
  const {
    state: { checkoutMetadata },
  } = useMerchantContext();
  const config = checkoutMetadata?.uiAttributes?.urgencyNudgeConfig;

  return (
    <GenericDialog
      isOpen={isOpen}
      setIsOpen={closePopup}
      translateAxis="y"
      dialogOverlay
      modalType="EXIT_CONFIRMATION"
      customClass="!overflow-visible md:!top-auto md:absolute rounded-t-2xl !p-0 max-h-[85vh]">
      <div className="flex flex-col px-5 pt-5 pb-6 antialiased">
        <div className="flex items-start justify-between mb-1">
          <h1 className="text-text-lg-semibold text-zinc-900 pr-4">{config?.title || t("wait")}</h1>
          <div className="flex items-center justify-center flex-shrink-0" style={{ height: 20 }}>
            <X size={16} weight="bold" className="text-zinc-500 cursor-pointer" onClick={closePopup} />
          </div>
        </div>

        {config?.fomoMessage && (
          <p className="text-text-sm-medium mb-5" style={{ color: config.textColor }}>
            {config.fomoMessage}
          </p>
        )}

        <div className="flex flex-col gap-2">
          <button
            type="button"
            className="w-full cursor-pointer py-3 rounded-[10px] text-text-md-semibold text-btnPrimaryText touch-manipulation bg-primary-dark active:[background:color-mix(in_srgb,var(--flo-primary-dark-color)_80%,#71717A_20%)]"
            onClick={closePopup}>
            {t("stay_in_checkout")}
          </button>
          <button
            type="button"
            className="w-full cursor-pointer py-3 rounded-[10px] text-text-md-semibold touch-manipulation border border-zinc-900/20 text-zinc-900/70 active:bg-zinc-500/10"
            onClick={() => {
              closePopup();
              closeCheckout();
            }}>
            {t("leave_checkout")}
          </button>
        </div>
      </div>
    </GenericDialog>
  );
};

export default UrgencyNudgePopup;
